import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Piano, Music, Music2, Mic } from 'lucide-react';
export function Results() {
  const results = [{
    icon: <Piano className="w-6 h-6" data-id="element-238" />,
    text: 'Dominar las bases de cada instrumento',
    color: 'gold'
  }, {
    icon: <Music className="w-6 h-6" data-id="element-239" />,
    text: 'Tocar acordes y melodías sin esfuerzo',
    color: 'magenta'
  }, {
    icon: <Music2 className="w-6 h-6" data-id="element-240" />,
    text: 'Coordinar ritmo, técnica y oído',
    color: 'cyan'
  }, {
    icon: <Mic className="w-6 h-6" data-id="element-241" />,
    text: 'Tocar canciones completas en tu estilo',
    color: 'violet'
  }];
  const colorClasses: Record<string, {
    bg: string;
    border: string;
    iconBg: string;
    iconText: string;
    glow: string;
    hoverBorder: string;
  }> = {
    gold: {
      bg: 'bg-gold/5',
      border: 'border-gold/20',
      iconBg: 'bg-gold/15',
      iconText: 'text-gold',
      glow: 'drop-shadow-glow-gold',
      hoverBorder: 'hover:border-gold/50'
    },
    magenta: {
      bg: 'bg-magenta/5',
      border: 'border-magenta/25',
      iconBg: 'bg-magenta/15',
      iconText: 'text-magenta-light',
      glow: 'drop-shadow-glow-magenta',
      hoverBorder: 'hover:border-magenta/50'
    },
    cyan: {
      bg: 'bg-cyan/5',
      border: 'border-cyan/25',
      iconBg: 'bg-cyan/15',
      iconText: 'text-cyan',
      glow: 'drop-shadow-glow-cyan',
      hoverBorder: 'hover:border-cyan/50'
    },
    violet: {
      bg: 'bg-violet/5',
      border: 'border-violet/25',
      iconBg: 'bg-violet/15',
      iconText: 'text-violet-light',
      glow: 'drop-shadow-glow-violet',
      hoverBorder: 'hover:border-violet/50'
    }
  };
  return <section className="py-16 md:py-20 bg-navy-light relative overflow-hidden" data-id="element-242">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-243"></div>
      <div className="absolute top-10 left-0 w-72 h-72 bg-magenta/8 rounded-full blur-3xl pointer-events-none" data-id="element-244"></div>
      <div className="absolute bottom-10 right-0 w-72 h-72 bg-cyan/8 rounded-full blur-3xl pointer-events-none" data-id="element-245"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-246">
        <FadeIn data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-3" data-id="element-248">
            Lo que vas a{' '}
            <span className="text-gold drop-shadow-glow-gold" data-id="element-249">lograr</span>
          </h2>
          <p className="text-center text-beige/60 mb-12 text-lg" data-id="element-250">
            Con este método paso a paso
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-251">
          {results.map((result, index) => {
          const colors = colorClasses[result.color];
          return <FadeIn key={index} delay={index * 0.08} data-id="element-252">
                <div className={`${colors.bg} border ${colors.border} ${colors.hoverBorder} rounded-2xl p-5 flex flex-col items-center text-center gap-4 transition-all duration-300 h-full`} data-id="element-253">
                  <div className={`w-14 h-14 rounded-full ${colors.iconBg} ${colors.iconText} flex items-center justify-center ${colors.glow}`} data-id="element-254">
                    {result.icon}
                  </div>
                  <p className="text-base font-semibold text-beige leading-tight" data-id="element-255">
                    {result.text}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.4} data-id="element-256">
          <p className="text-center text-base md:text-lg text-beige/60 mt-10 italic max-w-2xl mx-auto" data-id="element-257">
            "Disfrutá tocar música sin presión, a tu ritmo y desde tu casa"
          </p>
        </FadeIn>
      </div>
    </section>;
}